'use strict'

export default {
  name: '{locale}',
  messages: {
    _default: () => { return 'Der Wert ist ungültig.' },
    after: (e, n) => { return 'Der  Wert muss nach ' + n[0] + ' liegen.' },
    alpha_dash: () => { return 'Der Wert darf alphanumerische Zeichen sowie Striche und Unterstriche enthalten.' },
    alpha_num: () => { return 'Der Wert darf nur alphanumerische Zeichen enthalten.' },
    alpha: () => { return 'Der Wert darf nur alphabetische Zeichen enthalten.' },
    before: (e, n) => { return 'Der Wert muss vor ' + n[0] + ' liegen.' },
    between: (e, n) => { return 'Der Wert muss zwischen ' + n.min + ' und ' + n.max + ' liegen.' },
    confirmed: (e, n) => { return 'Der Wert passt nicht zum Inhalt von ' + n[0] + '.' },
    date_between: (e, n) => { return 'Der Wert muss zwischen ' + n.min + ' und ' + n.max + ' liegen.' },
    date_format: (e, n) => { return 'Der Wert muss das Format ' + n[0] + ' haben.' },
    double: (e, n) => {
      void n === 0 && (n = [])
      let t = n.decimals || 'keine'
      return void t === 0 && (t = '*'), 'Der Wert muss numerisch sein und darf ' + (t === '*' ? '' : t) + ' Nachkommastellen enthalten.'
    },
    digits: (e, n) => { return 'Der Wert muss numerisch sein und exakt ' + n.length + ' Ziffern enthalten.' },
    dimensions: (e, n) => { return 'Der Wert muss ' + n.width + ' x ' + n.height + ' Bildpunkte groß sein.' },
    email: () => { return 'Der Wert muss eine gültige E-Mail-Adresse sein.' },
    ext: () => { return 'Der Wert muss eine gültige Datei sein.' },
    image: () => { return 'Der Wert muss eine Grafik sein.' },
    included: () => { return 'Der Inhalt muss ein gültiger Wert sein.' },
    ip: () => { return 'Der Wert muss eine gültige IP-Adresse sein.' },
    max: (e, n) => { return 'Der Wert darf nicht länger als ' + n.length + ' Zeichen sein.' },
    mimes: () => { return 'Der Wert muss einen gültigen Dateityp haben.' },
    min: (e, n) => { return 'Der Wert muss mindestens ' + n.length + ' Zeichen lang sein.' },
    min_value: (e, n) => {return 'Der Wert muss größer/gleich ' + n.min + ' sein.'},
    max_value: (e, n) => {return 'Der Wert muss kleiner/gleich ' + n.max + ' sein.'},
    excluded: () => { return 'Der Wert muss ein gültiger Wert sein.' },
    numeric: () => { return 'Der Wert darf nur numerische Zeichen enthalten.' },
    integer: () => { return 'Der Wert muss eine Ganzzahl sein.' },
    regex: () => { return 'Das Format des Wertes ist ungültig.' },
    required: () => { return 'Dieses Feld ist ein Pflichtfeld.' },
    size: (e, n) => {
      let t, i, u
      const r = n[0]
      return 'Der Wert muss kleiner als ' + (t = r, i = 1024, u = (t = Number(t) * i) === 0 ? 0 : Math.floor(Math.log(t) / Math.log(i)), 1 * (t / Math.pow(i, u)).toFixed(2) + ' ' + ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][u]) + ' sein.'
    },
    url: () => { return 'Der Wert ist keine gültige URL.' }
  }
}
